export var PaymentTermsType;
(function (PaymentTermsType) {
    PaymentTermsType[PaymentTermsType["STANDARD"] = 1] = "STANDARD";
    PaymentTermsType[PaymentTermsType["DATE_DRIVEN"] = 2] = "DATE_DRIVEN";
    PaymentTermsType[PaymentTermsType["DAY_OF_MONTH"] = 3] = "DAY_OF_MONTH";
})(PaymentTermsType || (PaymentTermsType = {}));
//# sourceMappingURL=payment-terms-type.js.map